import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 4.71 22 12.57"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 11c0-.434.352-.786.786-.786h20.428a.786.786 0 0 1 0 1.572H.786A.786.786 0 0 1 0 11Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.159 4.944a.786.786 0 0 1 1.11 0l5.5 5.5a.786.786 0 0 1 0 1.112l-5.5 5.5a.786.786 0 0 1-1.11-1.112L20.103 11 15.16 6.056a.786.786 0 0 1 0-1.112Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }